import { useMemo } from 'react';

import { useGetHasErrorStateSelector } from '../../hooks/use-get-has-form-error-selector/use-get-has-form-error-selector.hook';
import getBasicInfoFormLayout from '../get-basic-info-form-layout/get-basic-info-form-layout';
import { withBasicInfoData } from '../with-basic-info-data/with-basic-info-data';

// TODO: this function was made to have selector which is further passed
// to the withFormik layout component for conditional validateOnMount
// because using withFormik HoC, validateOnMount cannot be modified via props

const BasicInfoValidationHelper = (): JSX.Element => {
  const hasBasicInfoFormError = useGetHasErrorStateSelector();

  const Component = useMemo(
    () => withBasicInfoData(getBasicInfoFormLayout()),
    []
  );

  return <Component forceErrorsDisplay={hasBasicInfoFormError} />;
};

export default BasicInfoValidationHelper;
